module.exports = __webpack_public_path__ + "static/media/logo-light.1a587014.png";